module.exports = __webpack_public_path__ + "bbcba4837efd126fe1c793044ebe6c72.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/fries.png
// module id = 2388
// module chunks = 0